import { Button } from "components/ui/Button";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";
import type { FC } from "react";

export type BatchAction =
  | "mark_completed"
  | "mark_in_progress"
  | "mark_unresponded";

export type BatchActionBarProps = {
  /** 現在チェックされている件数. 0 のときは表示しない. */
  checkedCount: number;
  totalCount: number;
  onToggleAll: () => void;
  onClearSelection: () => void;
  onBatch: (action: BatchAction) => void;
};

/**
 * 左ペイン上部のスティッキー一括操作バー.
 * 1 件以上チェックされたときだけ表示される.
 * @param {BatchActionBarProps} props 選択状態とハンドラ
 * @return {JSX.Element|null} バー or null
 */
export const BatchActionBar: FC<BatchActionBarProps> = ({
  checkedCount,
  totalCount,
  onToggleAll,
  onClearSelection,
  onBatch,
}) => {
  if (checkedCount === 0) return null;
  const allChecked = checkedCount === totalCount;
  return (
    <div className="sticky top-0 z-10 px-3 py-2 border-b border-slate-200 flex items-center gap-2 flex-wrap bg-violet-50">
      <label className="flex items-center gap-1 text-xs cursor-pointer">
        <input
          type="checkbox"
          className="checkbox checkbox-xs"
          checked={allChecked}
          onChange={onToggleAll}
          aria-label="全て選択"
        />
        <span className="text-base-content/80 font-medium">
          {checkedCount} 件選択中
        </span>
      </label>

      <div className="flex gap-1">
        <Button
          type="button"
          size="xs"
          variant="outline"
          onClick={() => onBatch("mark_completed")}
        >
          <span className="inline-flex items-center gap-1">
            <Check size={12} aria-hidden />
            完了
          </span>
        </Button>
        <Button
          type="button"
          size="xs"
          variant="outline"
          onClick={() => onBatch("mark_in_progress")}
        >
          <span className="inline-flex items-center gap-1">
            <ArrowRight size={12} aria-hidden />
            対応中
          </span>
        </Button>
        <Button
          type="button"
          size="xs"
          variant="outline"
          onClick={() => onBatch("mark_unresponded")}
        >
          <span className="inline-flex items-center gap-1">
            <ArrowLeft size={12} aria-hidden />
            未対応に戻す
          </span>
        </Button>
      </div>

      <button
        type="button"
        onClick={onClearSelection}
        className="ml-auto text-xs text-base-content/60 hover:text-base-content"
      >
        選択解除
      </button>
    </div>
  );
};
